// ! TODO change for journey map requirements

import React, { Component } from "react";
import JourneyMap from "./JourneyMap";

class AggregateJourneyMap extends Component {

  render() {

    return (
      <JourneyMap key={this.props.index} journeyMap={this.props.journeyMap} horizontalLines={this.props.journeyMap.xRange} participant={false} dotColorBorderOnly={false} type='aggregate' titleTop='Task Order / Representative Task' xAxisPosition="top"/>
    );
  }
}

export default AggregateJourneyMap;


// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/AggregateJourneyMap.js